import React from "react";
import { Sidebar } from "primereact/sidebar";
import { FaChevronDown } from "react-icons/fa";
import Select from "react-select";
import { userRole } from "../Constant/Constant";
import CustomSelect from "../common/CustomSelect";

const PipelineFilter = ({
  visible,
  onHide,
  teams,
  selectedTeam,
  handleTeamChange,
  handlePropertyChange,
  selectedProperty,
  properties,
  users,
  handleUserChange,
  selectedUser,
  handleApplyFilter,
  clearFilters,
  errors,
}) => {
  const userOptions = users.map((user) => ({
    value: user.id,
    label: user.name,
  }));

  const teamOptions = teams
  .sort((a, b) => a.name.localeCompare(b.name))
  .map((team) => ({
    value: team.teamId || team.id,
    label: team.name,
  }));


  const propertyOptions = properties.map((property) => ({
    value: property.id,
    label: property.name,
  }));


  const selectedTeamId = teamOptions.find((team) => team.value === selectedTeam)?.value || null;
  console.log("Selected Team ID:", selectedTeam);
  return (
    <>
      <Sidebar
        header={
          <div className="flex align-items-center gap-2">
            <span className="font-bold">Pipeline Filter</span>
          </div>
        }
        visible={visible}
        onHide={onHide}
        position="right"
      >
        <div className="border-2 border-slate-200 rounded-md p-3 flex flex-col gap-4">
          {/* Team */}
          <div className="w-full cursor-pointer relative">
            <CustomSelect
              options={teamOptions}
              onChange={(selectedOption) =>
                handleTeamChange(selectedOption?.value)
              }
              value={
                teamOptions.find(
                  (team) => team.value === selectedTeam
                ) || null
              }

              placeholder="Select Team"
              isClearable
              disabled={!!selectedUser || userRole === "BOD"}
            />
          </div>

          {/* Property */}
          <div className="w-full cursor-pointer relative">
            <CustomSelect
              options={propertyOptions}
              onChange={(selectedOption) =>
                handlePropertyChange(selectedOption?.value)
              }
              value={
                propertyOptions.find(
                  (prop) => prop.value === selectedProperty
                ) || null
              }
              placeholder="Select Property"
              isClearable
              isDisabled={!!selectedUser}
              className={errors.properties && "border-red-500"}
            />
          </div>
        </div>

        {(userRole === "Admin" || userRole === "CMO") && (
          <>
            <div className="inline-flex items-center justify-center w-full">
              <hr className="w-64 h-px my-8 bg-gray-400 border-0" />
              <span className="absolute px-3 font-medium text-gray-900 -translate-x-1/2 bg-white left-1/2">
                or
              </span>
            </div>

            {/* User */}
            <div className="w-full cursor-pointer relative p-3">
              <CustomSelect
                options={userOptions}
                onChange={(selectedOption) =>
                  handleUserChange(selectedOption?.value)
                }
                value={
                  userOptions.find((opt) => opt.value === selectedUser) || null
                }
                placeholder="Select User"
                isClearable
                disabled={!!selectedTeam || !!selectedProperty}
                className={errors.user && "border-red-500"}
              />
{/*              
              <Select
                className="appearance-none cursor-pointer w-full shadow border-2 border-customGreen rounded-md text-gray-700"
                options={userOptions}
                onChange={(selectedOption) =>
                  handleUserChange(selectedOption?.value)
                }
                value={
                  userOptions.find((opt) => opt.value === selectedUser) || null
                }
                placeholder="Select User"
                isClearable
                isDisabled={!!selectedTeam || !!selectedProperty}
              /> */}
            </div>
          </>
        )}

        <div className="flex flex-col gap-4 p-3 bottom-0">
          <button
            className="bg-customGreen text-white py-2 px-4 rounded-md hover:bg-appGreenHover transition duration-300 w-full mt-4"
            onClick={handleApplyFilter}
          >
            Apply Filters
          </button>
          <button
            className="bg-white text-customGreen border border-customGreen py-2 px-4 rounded-md hover:bg-gray-100 transition duration-300 w-full"
            onClick={clearFilters}
          >
            Clear Filters
          </button>
        </div>
      </Sidebar>
    </>
  );
};

export default PipelineFilter;